import type { FireIconProps } from './types';

export default function HoseNozzle({ size = 24, color = 'currentColor', strokeWidth = 2, className, ...props }: FireIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      className={className} {...props}>
      {/* Nozzle tip */}
      <path d="M3 12l4-2v4z" />
      {/* Nozzle barrel */}
      <rect x="7" y="10" width="6" height="4" rx="0.5" />
      {/* Grip / handle */}
      <rect x="13" y="9" width="3" height="6" rx="1" />
      {/* Hose coupling */}
      <line x1="16" y1="10" x2="16" y2="14" />
      {/* Hose */}
      <path d="M16 12c2 0 3 1 4 2s2 2 4 2" />
      {/* Handle lever */}
      <line x1="14" y1="9" x2="14" y2="6" />
      <line x1="13" y1="6" x2="15.5" y2="6" />
    </svg>
  );
}
